const comments = [
  {
    avatar: 'https://readdy.ai/api/search-image?query=A%20professional%20avatar%20portrait%20of%20a%20young%20Chinese%20person%20with%20warm%20friendly%20expression%2C%20minimalist%20cream%20background%2C%20soft%20natural%20lighting%2C%20clean%20professional%20headshot%20style&width=100&height=100&seq=avatar-user-01&orientation=squarish',
    name: '吃瓜路人甲',
    time: '2小时前',
    content: '这个导航网站真的太好用了！以前找各种网址要翻半天收藏夹，现在打开51网址导航，什么热门事件、常用工具全都有，网址123一键直达，上网效率直接翻倍！',
    likes: 326,
  },
  {
    avatar: 'https://readdy.ai/api/search-image?query=A%20friendly%20avatar%20portrait%20of%20a%20young%20Chinese%20woman%20with%20warm%20smile%2C%20minimalist%20cream%20background%2C%20soft%20natural%20lighting%2C%20clean%20professional%20headshot%20style&width=100&height=100&seq=avatar-user-02&orientation=squarish',
    name: '网购小能手',
    time: '5小时前',
    content: '每天必刷的首页！吃瓜资讯更新特别快，导航123的功能也很贴心，把123导航、网址导航123这些常用入口都整合在一起了，再也不用记一堆网址。',
    likes: 198,
  },
  {
    avatar: 'https://readdy.ai/api/search-image?query=A%20casual%20avatar%20portrait%20of%20a%20young%20Chinese%20man%20with%20relaxed%20expression%2C%20minimalist%20cream%20background%2C%20soft%20natural%20lighting%2C%20clean%20professional%20headshot%20style&width=100&height=100&seq=avatar-user-03&orientation=squarish',
    name: '科技数码控',
    time: '8小时前',
    content: '作为一个重度上网用户，真心推荐51网址导航！不仅集成了导航123等快捷入口，还能实时追踪社会热点和科技资讯，每天打开就能掌握全网动态，强烈安利给所有上网导航需求的朋友。',
    likes: 457,
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950 mb-3">网友热议</h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-[480px] mx-auto">
            真实用户反馈，听听大家怎么说
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-5 max-w-[1000px] mx-auto">
          {comments.map((comment, i) => (
            <div
              key={i}
              className="bg-background-50 rounded-xl p-5 md:p-6 border border-background-200/70"
            >
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 md:w-11 md:h-11 rounded-full overflow-hidden flex-shrink-0 border-2 border-background-100">
                  <img
                    src={comment.avatar}
                    alt={comment.name}
                    className="w-full h-full object-cover"
                    width="100"
                    height="100"
                  />
                </div>
                <div>
                  <div className="font-semibold text-sm text-foreground-900">{comment.name}</div>
                  <div className="text-xs text-foreground-400">{comment.time}</div>
                </div>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed mb-4">
                {comment.content}
              </p>
              <div className="flex items-center gap-1 text-foreground-400 text-xs">
                <i className="ri-thumb-up-line"></i>
                <span>{comment.likes}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}